// import { useState } from "react";
import BrandedLogo from "../components/branded-logo";
// import AnimationIcons from "../components/Auth/AnimationIcons";
// import Loginform from "../components/Auth/login-form";
// import Resetform from "../components/Auth/reset-form";
import MicrosoftLogin from "../components/Auth/microsoft-login";
// import { useSearchParams } from 'react-router-dom'

const Auth = () => {
  // const [searchParams, setSearchParams] = useSearchParams()
  // const [type, setType] = useState<string>(searchParams.get('step') || 'auth')
  // const [scaleAnimation, setScaleAnimation] = useState<string>('')
  // const [iconScaleAnimation, setIconScaleAnimation] = useState<string>('')

  // const HandleFlip = () => {
  //     setScaleAnimation(scaleAnimation === 'animate-login-scale' ? 'animate-forgot-scale' : 'animate-login-scale')
  //     setIconScaleAnimation('animate-login-icons-scale')
  //     setType((prev) => prev === 'auth' ? 'reset' : 'auth')
  //     setSearchParams({ step: type === 'auth' ? 'reset' : 'auth' })

  //     setTimeout(() => {
  //         setIconScaleAnimation('')
  //     }, 2000);
  // }

  return (
    <div className="w-[100%] h-[100vh] bg-background flex flex-col lg:flex-row items-center justify-between overflow-y-auto overflow-x-hidden smallTablet:h-[100dvh] smallTablet:justify-start smallTablet:py-8 smallTablet:gap-4">
      {/* AUTH PAGE LOGO */}
      <div className="w-[100%] lg:w-[45%] h-[100%] flex items-center justify-center relative z-10 smallTablet:h-auto smallTablet:shrink-0">
        <div className="h-[200px] w-[450px] lg:h-[400px] smallTablet:w-[280px] smallTablet:h-[160px] blur-3xl rounded-[50%] bg-indigo-600/20 absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] animate-pulse"></div>
        <div className="p-[30px] text-center border-r-[50%] relative animate-fade-in-slow mobile:p-4">
          <p className="text-[35px] lg:text-[55px]">👋</p>
          <h4 className="text-text-secondary text-[22px] lg:text-[28px] font-medium">
            Welcome to
          </h4>
          <BrandedLogo
            alt=""
            className=" w-[200px] lg:w-[300px] mt-2 h-[auto] object-cover"
          />
        </div>
      </div>
      {/* AUTH PAGE LOGO */}

      {/* LOGIN AND RESET FORM */}

      <div className="w-[100%] lg:w-[55%] h-full flex items-center justify-center smallTablet:h-auto smallTablet:shrink-0 smallTablet:px-4">
        <div
          className={`w-[90%] lg:w-[55%] max-w-[430px] h-[480px] smallTablet:w-full relative [perspective:1000px] `}
        >
          {/* <AnimationIcons animationClass={iconScaleAnimation} /> */}
          {/* <div className={`h-full w-full relative transition-all duration-500 [transform-style:preserve-3d] [transform:rotateY(${type === 'auth' ? 0 : 180}deg)] ${scaleAnimation}`}>
           */}

          <div
            className={`h-full w-full relative transition-all duration-500 [transform-style:preserve-3d] [transform:rotateY(0deg)] `}
          >
            {/*------------------------------- LOGIN FORM --------------------- */}
            {/* <Loginform HandleFlip={HandleFlip} /> */}
            {/*------------------------------- LOGIN FORM --------------------- */}
            <MicrosoftLogin />
            {/*------------------------------- FORGOT PASSWORD FORM --------------------- */}
            {/* <Resetform HandleFlip={HandleFlip} /> */}
            {/*------------------------------- FORGOT PASSWORD FORM --------------------- */}
          </div>
        </div>
      </div>

      {/* LOGIN AND RESET FORM */}
    </div>
  );
};

export default Auth;
